import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "whiteSuccessCheckmark",
  "use": "whiteSuccessCheckmark-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"whiteSuccessCheckmark\"><path fill=\"#031425\" d=\"M0 0h12v12H0z\" /><path d=\"M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12z\" fill=\"#fff\" /><path d=\"M9.105 3.537a.339.339 0 0 0-.478.032l-3.61 4.127-1.65-1.761a.34.34 0 0 0-.495.464l1.91 2.034a.34.34 0 0 0 .247.107.337.337 0 0 0 .25-.116l3.856-4.408a.339.339 0 0 0-.03-.479z\" fill=\"#031425\" stroke=\"#031425\" stroke-width=\".2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol